import http from "../http/http-config";
export default new class CRMCotizadorWebService {

    CreateOrEditLead(
        leadId,email, url, telephoneArea, telephoneNumber, productId, toQualify, applicationStep, additionalInformation: { [key: string]: string }, lastName , firstName
    ): Promise<string> {
        return http.post<string>("CreateOrEditLead", {    
                leadId
                ,email
                , url
                , telephoneArea
                , telephoneNumber
                , productId
                , toQualify
                , applicationStep
                , additionalInformation
                , lastName
                , firstName
        }).then(response => response.data)
    };    

    D365_AddFinishedQuotation(
        apellido, dni, localidad, mail, nombre, nroCotizacion, premioMensual, productoComercial, ramo, telephoneArea, telephoneNumber
    ): Promise<string> {
        return http.post<string>("D365_AddFinishedQuotation", {
            apellido
            , dni
            , localidad
            , mail
            , nombre
            , nroCotizacion
            , premioMensual
            , productoComercial
            , ramo
            , telephoneArea
            , telephoneNumber
        }).then(response => response.data)
    };
}